module.exports = __webpack_public_path__ + "img/bg03.b6134cb2.png";